import { createContext, useContext, useState, useEffect } from "react";

export const ROLES = [
  { id: "safeguarding_lead", label: "Safeguarding Lead", name: "Sarah Holloway" },
  { id: "maintenance_lead", label: "Maintenance Lead", name: "Mark Whitfield" },
  { id: "club_secretary", label: "Club Secretary", name: "David Okafor" },
  { id: "committee", label: "Committee View", name: "Committee Member" },
  { id: "parent_guardian", label: "Parent / Guardian", name: "Parent (T. Reid)" },
];

const RoleCtx = createContext(null);

export function RoleProvider({ children }) {
  const [role, setRole] = useState(() => {
    const stored = typeof window !== "undefined" ? localStorage.getItem("cc_role") : null;
    return ROLES.find((r) => r.id === stored) || ROLES[2];
  });
  useEffect(() => { localStorage.setItem("cc_role", role.id); }, [role]);
  return <RoleCtx.Provider value={{ role, setRole }}>{children}</RoleCtx.Provider>;
}

export const useRole = () => useContext(RoleCtx);
